goog.provide('el8.uiwidget.CollapsibleFeedRenderer');

goog.require('el8.model.base');
goog.require('el8.uiwidget.FeedRenderer');


/**
 * Renderer helper for CollapsibleFeed. Expects items with getId() method.
 */
el8.uiwidget.CollapsibleFeedRenderer = function(spec) {

    spec = spec || {};

    /**
     * Useful classes and selectors
     */
    this._collapseEltClass = spec.collapseEltClass || 'feedItemContent';
    this._collapseBtnClass = 'collapseButton';
    this._expandedClass = 'feedItemExpanded';
    this._collapsedClass = 'feedItemCollapsed';
    this._contentWrapperClass = spec.contentWrapperClass || null;

    /**
     * Relevant DOM elements
     */
    this._scrollContainer = spec.scrollContainer;

    /**
     * Useful rendering functions
     */
    this._contentRendererFn = spec.contentRendererFn || function() {};
    this._addlExpandItemFn = spec.addlExpandItemFn || null;
    this._addlCollapseItemFn = spec.addlCollapseItemFn || null;

    spec['highlightClass'] = 'el8Highlight';
    el8.uiwidget.FeedRenderer.prototype.constructor.call(this, spec);

    this._addlRenderItemFn = function($elt, item) {
        if (spec.addlRenderItemFn) {
            spec.addlRenderItemFn.apply(this, arguments);
        }
        if (this._expandedIds.hasOwnProperty(item.getId())) {
            this.expandItem(item, true);
        } else {
            this.collapseItem(item);
        }
    };

    /***************
     * Holds state *
     ***************/
    this._expandedIds = {};

};
el8.uiwidget.CollapsibleFeedRenderer.inheritsFrom(el8.uiwidget.FeedRenderer);

/**
 * New methods specific to collapsible feeds that manage expanding
 * and collapsing of feed items
 */
el8.uiwidget.CollapsibleFeedRenderer.prototype.collapseItem = function(item) {

    if (!item) { return; }

    var itemId = item.getId();

    var wasExpanded = Boolean(this._expandedIds[itemId]);
    delete this._expandedIds[itemId];
    var divElt = this.getRenderItem(itemId);

    // Hide the collapsed content
    $('.'+this._collapseEltClass, divElt).hide();

    // Do UI styling changes
    divElt.find('.statusText').html(el8.template.core.expandIcon());
    divElt.swapClasses(this._expandedClass, this._collapseClass);

    if (this._addlCollapseItemFn) { this._addlCollapseItemFn(item, divElt); }

    return wasExpanded;
};
el8.uiwidget.CollapsibleFeedRenderer.prototype.expandItem = function(item, notByUser) {

    if (!item) { return; }

    var itemId = item.getId();

    var wasCollapsed = !Boolean(this._expandedIds[itemId]);
    this._expandedIds[itemId] = true;
    var divElt = this.getRenderItem(itemId);

    // Show the collapse content
    var collapseContent = $('.'+this._collapseEltClass, divElt);
    if (!collapseContent.length) {
        if (this._contentWrapperClass) {
            $('.'+this._contentWrapperClass, divElt).append(this._renderItemContent(item));
        } else {
            divElt.append(this._renderItemContent(item));
        }
    } else {
        collapseContent.show();
    }

    // Do UI styling changes
    divElt.find('.statusText').html(el8.template.core.collapseIcon());
    divElt.swapClasses(this._collapsedClass, this._expandedClass);

    if (this._addlExpandItemFn) { this._addlExpandItemFn(item, divElt, notByUser); }

    return wasCollapsed;

};
el8.uiwidget.CollapsibleFeedRenderer.prototype._renderItemContent = function(item) {
    return this._contentRendererFn(item)
        (item, this._feedIdFn(item.getId()), this._collapseEltClass, this._collapseBtnClass);
};
el8.uiwidget.CollapsibleFeedRenderer.prototype.toggleItem = function(item) {
    if (!this._feedData.hasItem(item.getId())) { return; }
    if (this._expandedIds[item.getId()]) {
        this.collapseItem(item);
    } else {
        this.expandItem(item);
    }
};
el8.uiwidget.CollapsibleFeedRenderer.prototype.expandNthItem = function(n) {
    /* 0-based index */
    var item = this._feedData.fetchNthItem(n);
    this.expandItem(item);
};


/**
 * New methods specific to collapsible feeds for managing refreshing
 * and removing of items
 */
el8.uiwidget.CollapsibleFeedRenderer.prototype.refreshRenderItem = function(itemId, force) {
    var wasExpanded = this._expandedIds[itemId];
    var retVal = el8.uiwidget.FeedRenderer.prototype.refreshRenderItem.apply(this, arguments);
    if (retVal) {
        /* Make sure to leave in same expanded or collapsed state as before */
        var item = retVal;
        if (wasExpanded) {
            this.expandItem(item, true);
        } else {
            this.collapseItem(item);
        }
    }
};

/**
 * Over-ride existing methods for collapsible feed highlighting
 */
el8.uiwidget.CollapsibleFeedRenderer.prototype.highlight = function(itemId) {
    if (this._contentWrapperClass) {
        var divElt = this.getRenderItem(itemId);
        $('.'+this.highlightClass, this._list).removeClass(this._highlightClass);
        $('.'+this._contentWrapperClass, divElt).addClass(this._highlightClass);
    } else {
        el8.uiwidget.FeedRenderer.prototype.highlight.call(this, itemId);
    }
};
el8.uiwidget.CollapsibleFeedRenderer.prototype.unhighlight = function(itemId) {
    if (this._contentWrapperClass) {
        var divElt = this.getRenderItem(itemId);
        $('.'+this._contentWrapperClass, divElt).removeClass(this._highlightClass);
    } else {
        el8.uiwidget.FeedRenderer.prototype.unhighlight.call(this, itemId);
    }
};
